import React from 'react'
import HeroBanner from '../component/Common Banner Component/HeroBanner'
import Footer from '../component/Footer/Footer'
import Contactform from '../component/Contact Form/Contactform'
import DecoratingInteriorDesign from '../component/DecoratingInteriorDesign/DecoratingInteriorDesign'
import { Helmet } from 'react-helmet'
import SalesCard from '../component/SalesCard/SalesCard'

const cardData = [
    {
        title:"Styling Consultation - $495 (up to 3 hours max)",
        list:[
            "In-home or virtual walk-through",
            "Design guidance on layout, colour, furniture, and lighting",
            "Summary email with main recommendations"
        ]
    },
    {
        title:"Style & Shop Package - Starting at $1,450",
        list:[
            "In-house or virtual walk-through Styling Consultation (Up to 3 hours max value at $495)",
            "Design concept mood board (digital)",
            "Shopping list with clickable links (retail)",
            "1 revision included",
            "Up to 2 rooms (additional room: +$600)",
            "Optional add-on: Done-for-you shopping & setup – starting at $750",
        ]
    },
    {
        title:"Full-Service Decorating & Setup - Starting at $2,950",
        list:[
            "In-house or virtual walk-through Styling Consultation (Up to 3 hours max valued at $495)",
            "Design concept mood board (digital)",
            "Space planning (CAD Drawing)",
            "Trade coordination (if needed)",
            "Product sourcing & ordering (wholesale)",
            "Installation + styling",
            "Ideal for living room/dining room makeovers or whole home refresh",
            "Can be broken into 2–3 milestone payments",
            "Optional add-on: Supplier market visit (up to three suppliers) – starting at $199/ Hour",
        ]
    },

]

function Decorating() {
    return (
        <>
                      
            <Helmet>
                <title> 
                Expert Decorating Services | Interior Design Service Consultation Canada
                </title>
                <meta 
                name='description' 
                content="Discover MES Décors' expert decorating services for homes and businesses. Enhance your space with personalized, stylish, and creative interior design solutions and Consultation in Canada" 
                />
<link rel="canonical" href="https://www.mesdecors.ca/decorating" />
                </Helmet>
        
            <HeroBanner 
                subHeading=""
                Heading="Decorating"
                nextLineSpanHeading=""
                Paragraph="Transform your space into a reflection of your style and personality with our expert decorating services. Let us bring your vision to life, one beautiful detail at a time."
                bgImg="/images/creatives/decorating-hero-bg.jpg"
                btn={false}
                sideLinks={false}
            />
    
          <DecoratingInteriorDesign
            Heading="A BROAD SET OF INTERIOR DESIGN"
            content="Discover the art of interior design with MES Décors. Our comprehensive approach encompasses everything from color palettes to furniture arrangement, ensuring every aspect of your space harmonizes seamlessly. With a keen eye for detail and a passion for creativity, we turn ordinary rooms into extraordinary living spaces. From contemporary chic to timeless elegance, our diverse range of interior design services caters to every taste and style. Let us unleash the full potential of your home and create a space that truly reflects who you are."
            

          />

          <SalesCard
          heading='Interior Styling/ Decorating Packages'
            cardData={cardData}
          />
           
          <Contactform/>
          <Footer
            newsletterSection={true}
          />
        </>
      )
}

export default Decorating